// Button click effect

// eslint-disable-next-line func-names
(function ($, window, Drupal) {
  const handleLink = (e) => {
    const { btn, url, ripple } = e.data;
    $(btn).removeClass('active');
    if (ripple) {
      $(ripple).off('animationend');
    }
    if (url) {
      window.open(url, '_self');
    }
  };

  const onClick = (e) => {
    const el = e.target;
    const downloadable =
      el.parentElement.parentElement.previousElementSibling &&
      el.parentElement.parentElement.previousElementSibling.classList.contains(
        'downloadable__icon',
      );

    let btn;

    if (downloadable) {
      btn = el.parentElement.parentElement.parentElement;
    } else if (e.target.matches('input')) {
      btn = el.parentElement;
    } else {
      btn =
        e.target.matches('button') || e.target.matches('a')
          ? el
          : e.target.closest('button') || e.target.closest('a');
    }

    if (btn) {
      const url = $(btn).attr('href');
      const target = $(btn).attr('target');
      btn.classList.add('active');

      if (url) {
        e.preventDefault();

        if (target === '_blank') {
          return window.open(url, target);
        }
      }

      const ripple = $(btn).find('.btn__ripple');

      if (ripple.length > 0) {
        $(ripple).on('animationend', { btn, url, ripple }, handleLink);
      } else {
        handleLink({ data: { btn, url } });
      }
    }
  };

  function initButtonClickEffect(btn) {
    btn.classList.remove('active');

    btn.addEventListener('click', onClick);
  }
  Drupal.behaviors.mstButtonClickEffect = {
    attach(context) {
      $('.btn, .downloadable, .line-teaser', context).each((index, element) => initButtonClickEffect(element));
    },
  };
}(jQuery, window, Drupal));
